import React from "react";
import AboutView from "../pages/about";
import AboutUsPage from "../pages/about/AboutUsPage";
import AppliedJobDetails from "../pages/applied-job-details";
import CampusConnect from "../pages/campus-connect";
import ContactPage from "../pages/contact-us/ContactPage.jsx";
import CurrentAffairs from "../pages/current-affairs";
import EduConnectPage from "../pages/edu connect/EduConnectPage";
import ExploreJob from "../pages/explore-job/index";
import FraudAlert from "../pages/fraud alert/FraudAlert.jsx";
import FreshersJob from "../pages/freshers-job";
import Internship from "../pages/internships";
import FreshmentAppPage from "../pages/freshment app/FreshmentAppPage";
import GovernmentJob from "../pages/government-job";
import HomePage from "../pages/homePage";
import ProfilePage from "../pages/My Profile/ProfilePage";
import PostYourJob from "../pages/postyourjob";
import PrivacyPolicyPageView from "../pages/privacy-policy";
import PrivacyPolicy from "../pages/privacy-policy/PrivacyPolicy";
import StudyMaterial from "../pages/study-material";
import TalentConnectPage from "../pages/Talent Connect Page/TalentConnectPage";
import TermandCondition from "../pages/terms-conditions";
import TermsCondition from "../pages/terms-conditions/TermsCondition";
import CollegeAlertsPage from "../pages/College Alerts Page/CollegeAlertsPage";
import JobDescription from "../pages/job-description";
import { StartupOdisha } from "../pages/startup-odisha";
import IndustryCoursesPage from "../pages/industry-courses/IndustryCoursesPage";
import ChangePasswordPage from "../pages/change-password/ChangePasswordPage";


const mainRoutes = [
  {
    path: "/",
    element: <HomePage />,
  },

  {
    path: "government-job",
    element: <GovernmentJob />,
  },
  {
    path: "freshers-job",
    element: <FreshersJob />,
  },
  {
    path: "internship",
    element: <Internship />,
  },
  {
    path: "explore-job",
    element: <ExploreJob />,
  },
  {
    path: "post-your-job",
    element: <PostYourJob />,
  },
  {
    path: "current-affairs",
    element: <CurrentAffairs />,
  },
  {
    path: "study-material",
    element: <StudyMaterial />,
  },
  {
    path: "terms-conditions",
    element: <TermsCondition />,
  },
  {
    path: "campus-connect",
    element: <CampusConnect />,
  },
  {
    path: "privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "about",
    element: <AboutUsPage />,
  },
  {
    path: "contact-us",
    element: <ContactPage />,
  },
  {
    path: "fraud-alert",
    element: <FraudAlert />,
  },
  {
    path: "edu-connect",
    element: <EduConnectPage />,
  },
  {
    path: "startup-odisha",
    element: <StartupOdisha />,
  },
  {
    path: "freshment-app",
    element: <FreshmentAppPage />,
  },
  {
    path: "profile",
    element: <ProfilePage />,
  },
  {
    path: "industry-courses",
    element: <IndustryCoursesPage />,
  },
  {
    path: "change-password",
    element: <ChangePasswordPage />,
  },
  {
    path: "talent-connect",
    element: <TalentConnectPage />,
  },
  {
    path: "CollegeAlertsPage",
    element: <CollegeAlertsPage />,
  },
  {
    path: "job-description",
    // element: <JobDescription />,
    children: [
      {
        path: ":id",
        element: <JobDescription />,
      },
    ],
  },
  {
    path: "candidate-listing",
    children: [
      {
        path: ":companyId",
        children: [
          {
            path: ":job_id",
            children: [
              {
                path: ":access_token",
                element: <AppliedJobDetails />,
              },
            ],
          },
        ],
      },
    ],
  },
  // {
  //   path: "products",
  //   children: [
  //     {
  //       index: true,
  //       element: <Products />,
  //     },
  //     {
  //       path: ":productId",
  //       element: <Product />,
  //     },
  //   ],
  // },
];

export default mainRoutes;
